export { default as InstagramRegion } from './instagramRegion'



// WEBPACK FOOTER //
// ./src/modules/social-media/index.js